// @ts-ignore
import beApiClient from "@/src/be-api-client";
// @ts-ignore
import { makeRequest } from "../utils";
import { APIPagyResponse } from "../types";

export function makeGetRequest(url: string, payload: any = null) {
  return makeRequest(beApiClient.get, url, payload);
}

export function getPaginatedList(url: string, payload: any): Promise<APIPagyResponse> {
  return makeGetRequest(url, payload);
}